var map = {
	"./arrow-up-right.svg": "1dbd",
	"./canceled.svg": "d11a",
	"./check.svg": "3937",
	"./clock.svg": "4eaf",
	"./copy.svg": "66f0",
	"./dislike.svg": "4437",
	"./email.svg": "6777",
	"./gambling.svg": "6e44",
	"./hold.svg": "5dc0",
	"./lightning.svg": "97f8",
	"./like.svg": "6d89",
	"./nutra.svg": "1680",
	"./plus-circle.svg": "8f23",
	"./success.svg": "a823"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "033c";